<template>
  <div class="login" id="logo_scroll">
    <div class="login_wrap">
      <img class="bg" id="bg-img" src="./../../assets/images/admin/login_bg.png" alt="" />
      <div class="logo" @click="goPage">
        <!-- <img src="./../../assets/images/logo.png" height="64" alt=""> -->
        <img :src="siteLogo" height="64" alt="" />
        <div class="logo_text">
        <!--  <p>国家应急安全标识注册管理公共服务平台</p>
           <p>中国安全生产科学研究院</p> -->
		   <p>{{ websiteName }}</p>
          <!-- <p>China Academy of Safety Science and Technology</p> -->
        </div>
      </div>
      <div class="login_main" id="login_main">
        <h3 class="title"><span>欢迎登录</span>{{ websiteName }}</h3>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0"
          class="login_form"
        >
          <div class="tips">密码登录</div>
          <el-form-item label="" prop="username">
            <el-input
              v-model="ruleForm.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="" required>
            <el-col :span="8">
              <el-form-item prop="code">
                <el-input
                  v-model="ruleForm.code"
                  placeholder="验证码"
                  @keyup.enter.native="login"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="code" @click="kaptcha">
                <!-- <span>7364</span> -->
                <img :src="codeImg" alt="" />
                <img
                  src="./../../assets/images/refresh.png"
                  height="26"
                  alt=""
                />
              </div>
            </el-col>
          </el-form-item>
          <div class="btn_wrap">
            <el-button @click="login">登录</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { kaptcha, login, websiteInfo } from "@/api/admin";
export default {
  name: "Login",
  data() {
    return {
      siteLogo: "",
      ruleForm: {
        username: "", //用户名
        password: "", //密码
        code: "", //验证码
      },
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
      codeImg: "", //验证码
      websiteName: "", // 站点名称
    };
  },
  mounted() {
    this.kaptcha();
    this.getWebsite();
    let dom = document.getElementById('bg-img');
    dom.style.height = document.getElementById('logo_scroll').scrollHeight + 'px';
  },
  methods: {
    kaptcha() {
      //获取验证码
      kaptcha({}).then((res) => {
        // console.log('获取验证码')
        // console.log(res)
        this.codeImg = res.data;
      });
    },
    getWebsite() {
      //获取站点设置
      websiteInfo({}).then((res) => {
        this.websiteName = res.data.siteName;
        this.siteLogo = res.data.siteLogo;
      });
    },
    login() {
      //登录
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          login(this.ruleForm)
            .then((res) => {
              this.$message({
                message: res.errmsg,
                type: "success",
                duration: 2000,
                onClose: () => {
                  loading.close();
                  this.$store.commit("user/setUserInfo", res.data.userInfo);
                  this.$store.commit("user/setUnitInfo", res.data.unitInfo);
                  this.$router.push({
                    path: "/admin",
                  });
                },
              });
            })
            .catch(() => {
              loading.close();
              this.kaptcha();
            });
        } else {
          return false;
        }
      });
    },
    goPage() {
      //回官网首页
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  // border: 3px solid #f00;
  // overflow: hidden;
  width: 100vw;
  height: 100vh;
  //   overflow: auto;
  // box-sizing: border-box;
  // background: url('~@/assets/images/admin/login_bg.png') no-repeat center/100% 100%;
  .login_wrap {
    width: 100%;
    height: 100%;
    position: relative;
    // overflow: auto;
    // border: 3px solid #0f0;
    // box-sizing: border-box;
    min-width: 1440px;

    .bg {
      // position: absolute;
    //   top: 0;
    //   bottom: 0;
    //   left: 0;
    //   right: 0;
      width: 100%;
      height: 100%;
    }
    .logo {
      display: flex;
      align-items: center;
      background-color: #fff;
      position: absolute;
      top: 170px;
      left: 170px;
      padding: 15px;
      box-sizing: border-box;
      cursor: pointer;
      .logo_text {
        margin-left: 20px;
        color: #00aa73;
        white-space: nowrap;
        width: 100%;
        p {
          line-height: 25px;
          white-space: nowrap;
        }
        p:nth-child(1) {
          font-size: 21px;
          // color: #1A1A1A;
          font-weight: 600;
          letter-spacing: 3px;
          white-space: nowrap;
        }
        p:nth-child(2) {
         font-size: 19px;
        letter-spacing: 2px;
        }
      }
    }
    .login_main {
      // border: 3px solid #0f0;
      width: 450px;
      position: absolute;
      top: 170px;
      right: 15%;
      .title {
        text-align: center;
        color: #808080;
        font-size: 16px;
        font-weight: 400;
        span {
          color: #333;
          font-size: 26px;
          font-weight: 600;
          margin-right: 20px;
        }
      }
      .login_form {
        background-color: #fff;
        margin-top: 30px;
        box-shadow: 0px 0px 8px 0px #e4eeff;
        border-radius: 10px;
        padding: 70px 50px;
        box-sizing: border-box;
        .tips {
          font-weight: 600;
          color: #333;
          font-size: 20px;
          padding-bottom: 15px;
          border-bottom: 3px solid #00aa73;
          display: inline-block;
          margin-bottom: 30px;
        }
        ::v-deep {
          .el-input__inner {
          height: 60px;
          line-height: 60px;
          background-color: #f7f8fa;
          font-size: 16px;
        }
      }
        .code {
          // border: 1px solid #0f0;
          height: 60px;
          display: flex;
          align-items: center;
          // margin-left: 30px;
          // span{
          //     border: 1px solid #f00;
          //     padding: 5px 20px;
          //     box-sizing: border-box;
          // }
          > img {
            margin-left: 20px;
            cursor: pointer;
          }
        }
        .btn_wrap {
          // border: 1px solid #0f0;
          margin-top: 50px;
          .el-button {
            background-color: #00aa73;
            font-size: 20px;
            color: #fff;
            height: 60px;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
